export const selectHelper = (stateName) => (state) => state[stateName];
export const getUser = selectHelper('user');
export const getConfig = selectHelper('config');
